'use client'

import { useContext, useRef } from 'react'
import styles from './Navigation.module.scss'
import { GlobalSettingsContext } from '@/context/GlobalSettings'
import NavigationItems, { ContactMeLink, LocationHeader } from '@/components/Navigation/NavigationItems/NavigationItems'
import useStore from '@/store'
import classNames from 'classnames'
import useBreakpoint from '@/hooks/use-breakpoint'
import X from '@/components/_svgs/X'

export const HEADER_ID = 'header'

const Navigation = () => {
  const containerRef = useRef<HTMLElement>(null)
  const { navigationData } = useContext(GlobalSettingsContext)
  const navIsOpen = useStore(state => state.navIsOpen)
  const { isMobile } = useBreakpoint()
  const setNavIsOpen = useStore(state => state.setNavIsOpen)

  if (!navigationData) return null

  return (
    <>
      <header
        className={classNames(styles.Navigation, { [styles.navIsOpen]: navIsOpen })}
        ref={containerRef}
        id={HEADER_ID}
      >
        <div
          className={styles.desktopDrawerOuter}
          data-lenis-prevent-wheel
          data-lenis-prevent-touch
        >
          <div className={styles.desktopDrawer}>
            {isMobile && (
              <button
                onClick={() => {
                  setNavIsOpen(!navIsOpen)
                }}
                className={styles.desktopDrawer__xButton}
                aria-label="close navigation"
              >
                <X />
              </button>
            )}
            <NavigationItems />
            {!isMobile && <NavigationButton />}
          </div>
        </div>
      </header>
      {isMobile && <NavigationButton className={styles.navigationMobileButton} />}
    </>
  )
}

export const StaticNavigation = () => {
  const { isMobile } = useBreakpoint()
  const navIsOpen = useStore(state => state.navIsOpen)

  return (
    <>
      <LocationHeader
        className={classNames(styles.staticHeader__locationContent, { [styles.navIsOpen]: navIsOpen })}
        allowClock={!isMobile}
      />
      <ContactMeLink className={classNames(styles.staticHeader__contactContent, { [styles.navIsOpen]: navIsOpen })} />
    </>
  )
}

export const NavigationButton = ({ className }: { className?: string }) => {
  const navIsOpen = useStore(state => state.navIsOpen)
  const setNavIsOpen = useStore(state => state.setNavIsOpen)

  return (
    <button
      className={classNames(styles.NavigationButton, className)}
      aria-label="Open and Close Navigation"
      onClick={() => {
        setNavIsOpen(!navIsOpen)
      }}
    >
      <span className={styles.navigationButton__text}>{navIsOpen ? 'Close' : 'Menu'}</span>
    </button>
  )
}

Navigation.displayName = 'Navigation'

export default Navigation
